import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from '../../components/Modal';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { isEmptyData } from '../../utils/helper';

let isOpen = false;
let closeFn = null;
const listeners = new Set();

const emit = () => {
  listeners.forEach(fn => fn(isOpen));
};

export const closeError = () => {
	closeFn?.(false);
};

export const subscribeError = (callback) => {
  listeners.add(callback);

  callback(isOpen);

  return () => {
    listeners.delete(callback);
  };
};

export const isErrorOpen = () => isOpen;

export const showError = ({ title = '', description = '' }) => {
	if (isOpen) return Promise.resolve(false);

	isOpen = true;
  emit();

	return new Promise((resolve) => {
		const container = document.createElement('div');
		document.body.appendChild(container);

		const root = ReactDOM.createRoot(container);

		const handleClose = (result) => {
			isOpen = false;
			closeFn = null;
      emit();

			root.unmount();
			container.remove();
			resolve(result);
		};

		closeFn = handleClose;

		root.render(
			<Modal isOpen={true} onClose={() => handleClose(false)}>
				<div className='bg-white px-4 py-6 rounded-xl shadow-custom flex flex-col justify-center items-center gap-4 text-center'>
					<div className='bg-red-500 p-3 rounded-full'>
						<XCircleIcon class='h-14 w-auto text-white' />
					</div>
					<div className={`text-gray-900 text-sm font-semibold ${isEmptyData(title) && 'hidden'}`}>{title}</div>
					<div className={`text-gray-900 text-xxs font-normal  ${isEmptyData(description) && 'hidden'}`}>{description}</div>
					<button className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0 mt-4' id='got-it' onClick={() => handleClose(true)}>
						Mengerti
					</button>
				</div>
			</Modal>,
		);
	});
};
